var map = {
	"./wave-2-delta-pro.png": 336015,
	"./wave-2-delta-pro_au.png": 94743,
	"./wave-2-delta-pro_cn.png": 999721,
	"./wave-2-delta-pro_eu.png": 835652,
	"./wave-2-delta-pro_jp.png": 968984,
	"./wave-2-delta-pro_uk.png": 438016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974936;